import { Inbox } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function EmptyState({ icon: Icon = Inbox, title, description, action }) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-6 border border-dashed rounded-xl bg-gradient-to-b from-muted/20 to-transparent">
      <div className="w-14 h-14 rounded-2xl bg-background border shadow-elev-1 flex items-center justify-center mb-4">
        <Icon className="w-6 h-6 text-muted-foreground" strokeWidth={1.75} />
      </div>
      <div className="font-display font-semibold text-base tracking-tight">{title}</div>
      {description && <p className="text-sm text-muted-foreground mt-1.5 max-w-sm leading-relaxed">{description}</p>}
      {action && (
        <Button size="sm" className="mt-5 h-9 rounded-lg shadow-elev-2" onClick={action.onClick} data-testid={action.testid}>
          {action.icon ? <action.icon className="w-4 h-4 mr-2" /> : null}
          {action.label}
        </Button>
      )}
    </div>
  );
}
